import { apiSlice } from './apiSlice';
import { STOCKS_URL } from '../constants';

export const stocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new stock
    createStock: builder.mutation({
      query: (stock) => ({
        url: STOCKS_URL,
        method: 'POST',
        body: stock,
      }),
    }),
    // Get stock details by ID
    getStockDetails: builder.query({
      query: (id) => ({
        url: `${STOCKS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get logged-in user's stocks
    getMyStocks: builder.query({
      query: () => ({
        url: `${STOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get all stocks (Admin view)
    getStocks: builder.query({
      query: () => ({
        url: STOCKS_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // Mark a stock as delivered (Admin action)
    deliverStock: builder.mutation({
      query: (stockId) => ({
        url: `${STOCKS_URL}/${stockId}/deliver`,
        method: 'PUT',
      }),
    }),
    // Delete a stock (Admin action)
    deleteStock: builder.mutation({
      query: (stockId) => ({
        url: `${STOCKS_URL}/${stockId}`,
        method: 'DELETE',
      }),
    }),
    // Update a sale
        updateStock: builder.mutation({
          query: ({ stockId, updatedStock }) => ({
            url: `${STOCKS_URL}/${stockId}`,
            method: 'PUT',
            body: updatedStock,
          }),
        }),

  }),
});

export const {
  useCreateStockMutation,
  useGetStockDetailsQuery,
  useGetMyStocksQuery,
  useGetStocksQuery,
  useDeliverStockMutation,
  useDeleteStockMutation,
  useUpdateStockMutation,

} = stocksApiSlice;